/* global modForm Modalytics */
/**
 * FUTURE DEPRECATE: Fire non-TYP conversion path pixels
 * @param {*} [response] - Used to grab the zip
 * @returns {Boolean} - false if autoRedirectToTyOrSorryPage is also false
 */
export function fireNonTYPConversionPathPixels(response) {
	// https://modernize.atlassian.net/browse/HRC-349
	// temp check for HEX to follow landing page -> hrc funnel
	// will be removed once we're satisfied nonTYP experience isn't harmful to this funnel
	Modalytics.gaSend(
		{
			hitType: 'event',
			eventCategory: 'HRC General',
			eventAction: 'User converted on non-TYP experience',
			eventLabel: window.location.pathname
		},
		modForm.opts.gaTracker
	);

	// Redshift Transforms that normally happen on the TYP
	// window.paramObjs.formpath was used before, leaving this as a note
	const formPath = window.location.hostname + window.location.pathname;

	if (window.heap) {
		window.heap.addEventProperties({
			/* eslint-disable camelcase */
			project_id: window.projectId,
			form_path: formPath
			/* eslint-enable camelcase */
		});
	}

	// Adding active experiment data as heap event properties
	if (window.activeCampaignData) {
		if (window.heap) {
			window.heap.addEventProperties(window.activeCampaignData);
		}
	}

	const zip = response && response.zip ? response.zip : undefined;

	// Alternate heap conversion event for Homeowner Lead Form Conversion combo event
	modForm.homeownerLeadConversionProps.zip = zip;
	Modalytics.heap('track', ['Homeowner Lead Conversion', modForm.homeownerLeadConversionProps]);

	// track time elapsed between successful form post and HRC redirect
	modForm.redirectStart = Date.now();
	// Fire all conversion pixels
	if (typeof dataLayer !== 'undefined') {
		window.dataLayer.push({
			event: 'Homeowner Lead Conversion'
		});
	}

	if (!modForm.opts.autoRedirectToTyOrSorryPage) {
		return false;
	}

	// Trying to identify where the ~2% of submitted leads fail at
	Modalytics.heap('track', [
		'NonTYP Redirect Timer Start', {
			timeElapsed: Date.now()
		}
	]);

	// fallback in case AIO times out
	window.timeOutId = setTimeout(function() {
		const currentClasses = document.querySelector('body').getAttribute('class');
		Modalytics.heap('track', [
			'Hit Timeout to redirect to HRC',
			{
				classesPresent: currentClasses,
				timeElapsed: Date.now() - modForm.redirectStart
			}
		]);

		if (window.Loader && modForm.opts.showRedirectOverlay) {
			window.Loader.showRedirectAnimation(); // eslint-disable-line no-undef
			Modalytics.heap('track', ['Loader Visible - Transferring to Modernize']);
			setTimeout(function() {
				setTimeout(function() {
					window.location.href = modForm.projexURL;
				}, 500);
				document.body.classList.add('submitted');
			}, 2500);
		} else {
			document.body.classList.add('submitted');
			setTimeout(function() {
				window.location.href = modForm.projexURL;
			}, 500);
		}
	}, 5000);
}
